export default {
  GET_COLLECTION: state => state.collection,
  GET_META: state => state.meta,
  GET_USERS: state => state.users,
  GET_GROUPS: state => state.groups,
  GET_DATE: state => state.dateRange,
  GET_PRODUCTS: state => state.products,
  GET_USER_ACTIVE: state => state.userActive,
  GET_USER_TAB: state => state.userTab,
  GET_SETTINGS_LOADER: state => state.settingsLoader,
  GET_USERS_LOADING: state => state.userMeta.hasNextPage,
  GET_PAYMENT_METHOD: state => state.setPayMethod
};
